import Image from 'next/image';
import { HTMLAttributes } from 'react';
import styles from './Logo2.module.scss';

export const Logo2 = ( {
	className,
	...props
}: HTMLAttributes<HTMLDivElement> ) => (
	<div className={ `${ styles.logo } ${ className || '' }` } { ...props }>
		<Image src='/logo3.svg' fill alt='Rock Paper Coin logo' />
	</div>
);
